import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    Tooltip,
    Legend,
    Title,
} from "chart.js";

ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend, Title);

const LineCharts: React.FC = () => {
    const [data, setData] = useState<any>(null);
    const [question, setQuestion] = useState<string>("");
    const [correctAnswer, setCorrectAnswer] = useState<string>("");
    const [answer, setAnswer] = useState<string>("");
    const [error, setError] = useState(false);
    const [showImage, setShowImage] = useState(false);

    // Generate random line chart data
    const generateLineChartData = () => {
        const labels = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
        const values = Array.from({ length: 5 }, () => Math.floor(Math.random() * 20) + 1);

        return {
            labels,
            datasets: [
                {
                    label: "Toy Sales",
                    data: values,
                    borderColor: "#36A2EB",
                    backgroundColor: "rgba(54, 162, 235, 0.2)",
                    tension: 0.4,
                    fill: true,
                },
            ],
            rawData: values,
        };
    };

    // Generate a random question and its correct answer
    const generateQuestionAndAnswer = (values: number[]) => {
        const highestValue = Math.max(...values);
        const total = values.reduce((sum, value) => sum + value, 0);
        const randomIndex = Math.floor(Math.random() * 3) + 1; 

        const questionOptions = [
            { question: `What is the highest number of toys sold?`, answer: highestValue.toString() },
            { question: `What is the total number of toys sold?`, answer: total.toString() },
            { question: `How many toys were sold on ${data?.labels[randomIndex]}?`, answer: values[randomIndex].toString() },
        ];

        const randomQuestion = questionOptions[Math.floor(Math.random() * questionOptions.length)];
        return randomQuestion;
    };

    const handleSubmitAnswer = () => {
        if (answer && answer === correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                handleNewQuestion();
                setShowImage(false);
                setAnswer("");
                setError(false);
            }, 3000);
        } else {
            setError(true);
        }
    };

    const handleNewQuestion = () => {
        const chartData = generateLineChartData();
        const { question, answer } = generateQuestionAndAnswer(chartData.rawData);

        setData(chartData);
        setQuestion(question);
        setCorrectAnswer(answer);
    };

    useEffect(() => {
        handleNewQuestion();
        document.title = "Mamas Guidance - Class Two - Mathematics - Data Handling - Line Graphs"; // Set page title
    }, []);

    const chartOptions = {
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                bodyFont: {
                    size: 20,
                },
            },
            datalabels: {
                color: '#000',
                font: {
                    size: 16,
                },
            },
        },
        
        scales: {
            x: {
                ticks: {
                    font: {
                        size: 14,
                    },
                },
            },
            y: {
                ticks: {
                    font: {
                        size: 14,
                    },
                    beginAtZero: true,
                },
            },
        },
    };

    return (
        <>
            {showImage === false ? (
                <div className="contentPart showCenter additionWord">
                    <div className="pieChartDiv">
                        {data && (
                            <>
                                <div className="pieChart">
                                    <Line options={chartOptions} data={data} height={300} width={300} />
                                </div>
                                <div className="pieChartQuestionPart mt-3">
                                    <h3>{question}</h3>
                                    <div className="mb-4">
                                        <input
                                            type="text"
                                            value={answer}
                                            onChange={(e) => setAnswer(e.target.value)}
                                            style={{ width: "100%" }}
                                            className={`form-control blank-input ${error ? "error" : ""}`}
                                        />
                                    </div>
                                    <div className="text-center">
                                        <div className="optionButton" onClick={handleSubmitAnswer}>
                                            Submit
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            ) : (
                <div className="contentPart showMiddle">
                    <img
                        style={{ height: "150px" }}
                        className="img-fluid"
                        src={process.env.REACT_APP_WELDONE_LINK}
                        alt="Well Done"
                    />
                </div>
            )}
        </>
    );
};

export default LineCharts;
